import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, TUserInfo } from './types';

const initialState: AuthState = {
  currentUser: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<TUserInfo>) => {
      state.currentUser = action.payload;
    },
  },
});

export const { setUserInfo } = authSlice.actions;
export default authSlice.reducer;
